<template>
  <div class="sabbatical-container" v-if="isShow">
    <div class="sabbatical-label">
      <div class="sabbatical_month">{{ $t("sabbatical.sabbatical_month") }}</div>
      <div class="label-month">
        <span>{{ formatNumberOfMonth(sabbaticalMonth) }}</span
        >/{{ sabbaticalYear }}
      </div>
    </div>
    <div class="triangle"></div>
    <div class="sabbatical-details">
      <div v-if="sabbaticalInfo.fixBonus && Object.keys(sabbaticalInfo.fixBonus).length > 0">
        <div :class="formatNumber(sabbaticalInfo.fixBonus[index].daysOff) > 0 ? 't-green' :' t-red'" class="change-sabbatical"
          v-for="(item, index) in sabbaticalInfo.fixBonus" :key="index">
          <span v-if="formatNumber(sabbaticalInfo.fixBonus[index].daysOff) > 0">+{{ formatNumber(sabbaticalInfo.fixBonus[index].daysOff) }}</span>
          <span v-else>{{ formatNumber(sabbaticalInfo.fixBonus[index].daysOff) }}</span>
          {{ sabbaticalInfo.fixBonus[index].reason }}
        </div>
      </div>
      <div v-if="sabbaticalInfo.lawBonus && Object.keys(sabbaticalInfo.lawBonus).length > 0">
        <div class="change-sabbatical t-green" v-for="(item, index) in sabbaticalInfo.lawBonus" :key="index">
          <span>+{{ formatNumber(sabbaticalInfo.lawBonus[index]) }}</span>
          {{ $t("sabbatical.sabbatical_according_labor")}}
        </div>
      </div>
      <div v-if="sabbaticalInfo.otBonus && Object.keys(sabbaticalInfo.otBonus).length > 0">
        <div
          class="change-sabbatical t-orange"
          v-for="(item, index) in sabbaticalInfo.otBonus"
          :key="index"
        >
          <span>+{{ Math.round(item.count * 100)/100 }} </span> {{ $t("sabbatical.sabbatical_OT") }}
          {{  item.project }}
        </div>
      </div>
      <div v-if="sabbaticalInfo.sabbaticalSub && Object.keys(sabbaticalInfo.sabbaticalSub).length > 0">
        <div class="change-sabbatical t-red" v-for="(item, index) in sabbaticalInfo.sabbaticalSub" :key="index">
          <span>{{ sabbaticalInfo.sabbaticalSub[index] }}</span>
          {{ $t("sabbatical.sabbatical_day_off") }} {{ sabbaticalInfo.dataStartDate[index] }} {{ $t("fields.sabbatical.label_to")}} {{ sabbaticalInfo.dataEndDate[index] }}
        </div>
      </div>

      <div v-if="sabbaticalInfo.compensationValue && Object.keys(sabbaticalInfo.compensationValue).length > 0">
        <div class="change-sabbatical t-pink" v-for="(item, index) in sabbaticalInfo.compensationValue" :key="index">
          <span>{{ sabbaticalInfo.compensationValue[index] }}</span>
          {{$t('sabbatical.label_sabbtical_add_timesheet')}} {{ sabbaticalInfo.monthCompensation[index] }}
        </div>
      </div>

      <div class="change-sabbatical t-green" v-if="sabbaticalInfo.number_days_off">
        <span>{{ formatNumber(sabbaticalInfo.number_days_off) }}</span> {{ $t("sabbatical.sabbatical_leave_day")}}
      </div>
    </div>
  </div>
</template>
<script>
import { formatNumber } from "@/utils/ui";

export default {
  name: "SabbaticalItems",
  props: {
    sabbaticalInfo: {
      type: Object,
      default: function () {
        return {
          expireDate: "",
          numberDayOff: "",
          otBonus: {},
          lawBonus: "",
          fixBonus: "",
          sabbaticalSub: "",
          compensationValue:"",
          dateInfo: "",
          dataStartDate:"",
          dataEndDate:"",
          monthCompensation:"",
        }
      }
    },
  },
  data() {
    return {
      sabbaticalMonth: "",
      sabbaticalYear: "",
      isShow: false,
    };
  },
  created() {
    this.checkIsShowItem();
    if (this.sabbaticalInfo.month) {
      this.getTime(this.sabbaticalInfo.month);
    }
  },
  methods: {
    formatNumber,
    getTime(time) {
      const split = time.split("/");
      this.sabbaticalMonth = split[0];
      this.sabbaticalYear = split[1];
    },
    formatNumberOfMonth(number) {
      if (number < 10) return number.slice(1);
      return number;
    },
    checkIsShowItem() {
      if (
        this.sabbaticalInfo?.number_days_off ||
        this.sabbaticalInfo?.otBonus ||
        this.sabbaticalInfo?.lawBonus ||
        this.sabbaticalInfo?.sabbaticalSub
      ) {
        this.isShow = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.sabbatical-container {
  background: #ffffff;
  border: 1px solid #ededed;
  border-radius: 5px;
  padding: 10px;
  padding-left: 0px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .sabbatical-label {
    background-image: url("../../../assets/icons/3.svg");
    width: 115px;
    padding: 2px 12px;
    color: #ffffff;
    position: relative;
    border-radius: 5px;
    .sabbatical_month{
      margin-left: 12px;
    }
    .label-month {
      width: 90%;
      text-align: right;
      margin: -4px;
      span {
        font-weight: 700;
        font-size: 26px;
      }
    }
  }
  .sabbatical-details {
    margin: 8px 0 8px 17px;
    font-size: 14px;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    & > div:last-child,
    & > div:last-child > .change-sabbatical:last-child {
      margin-bottom: 0;
    }
    .change-sabbatical {
      padding-left: 7px;
      margin-bottom: 8px;
    }

    .t-green {
      border-left: 3px solid #118fa6;
      span {
        color: #118fa6;
      }
    }

    .t-pink
    {
      border-left: 3px solid #ee2ca3;
      span {
        color: #ee2ca3;
      }
    }

    .t-orange {
      border-left: 3px solid #ff9100;
      span {
        color: #ff9100;
      }
    }
    .t-red {
      border-left: 3px solid #f03d3e;
      span {
        color: #f03d3e;
      }
    }
  }
}
</style>
